import React, {PureComponent} from "react";
import Header from "../../components/Headers/Header";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    FormGroup, Input,
    Row,
    UncontrolledCollapse,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from "reactstrap";
import * as actions from "../../store/actions/actions";
import {Translate, withLocalize} from "react-localize-redux";
import {connect} from "react-redux";
import {FormControl} from "react-bootstrap";
import {
    PieChart, Pie, Legend, Tooltip, Cell, ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Bar, Line,ComposedChart,
} from 'recharts';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "./report.css";
import * as Roles from "../../store/actions/roles";
import { Multiselect } from 'multiselect-react-dropdown';
import italianReportTranslations from "../../translations/report/it.report.json";
import englishReportTranslations from "../../translations/report/en.report.json";
import ReactTooltip from "react-tooltip";
import domtoimage from 'dom-to-image';
class Report extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            bankEmpty: false
        };
        this.props.addTranslationForLanguage(italianReportTranslations, "it");
        this.props.addTranslationForLanguage(englishReportTranslations, "en");
    }

    componentDidMount() {
        this.props.fetchBanks()
        this.props.fetchPlickStatusType()
        this.props.fetchCorporates()
        if (this.props.banks !== null && this.props.banks !== 'undefined' &&
            this.props.banks.length > 0) {
            if (this.props.idBank !== null &&
                this.props.idBank !== 'undefined') {
                this.generalReportBankIdChangeSelect(this.props.banks, this.props.idBank)
            }
        }
        if (this.props.userCorporates !== null &&
            this.props.userCorporates !== 'undefined' &&
            this.props.userCorporates.length > 0) {
            if (this.props.corporateSenderId !== null &&
                this.props.corporateSenderId !== 'undefined') {
                this.generalReportCorporateIdChangeSelect(this.props.userCorporates, this.props.corporateSenderId.corporateSenderId)
            }
        }
    }
    
    toggleGeneralReportDetailModal = () => {
        this.props.toggleGeneralReportDetailModal()
    }
    
    toggleGeneralReportModal = () => {
        this.props.toggleGeneralReportModal()
    }
    
    generalReportBankIdChangeSelect = (selectedList) => {
        this.props.updateGRBankId(selectedList)
        let bankIdSelectedList = []
        selectedList.map(bank => {
            bankIdSelectedList.push(bank.bankId)
        })
        this.props.fetchBankCorporates(bankIdSelectedList)
    }

    generalReportBankIdChangeRemove = (selectedList) => {
        if(selectedList.length) {
            this.props.updateGRBankId(selectedList)
        }else{
            this.props.updateGRBankId(selectedList)
            this.props.updateGRCorporateId(selectedList)
            this.props.updateGRCampaignId(selectedList)
            this.props.updateGRFileId(selectedList)
        }

    }

    generalReportCorporateIdChangeSelect = (selectedList) => {
        this.props.updateGRCorporateId(selectedList)
        let corporateIds = []
        selectedList.map(corporate => {
            corporateIds.push(corporate.corporateSenderId)
        })
        this.props.fetchCorporateCampaigns(corporateIds)
    }

    generalReportCorporateIdChangeRemove = (selectedList) => {
        if(selectedList.length) {
            this.props.updateGRCorporateId(selectedList)
        }else{
            this.props.updateGRCorporateId(selectedList)
            this.props.updateGRCampaignId(selectedList)
            this.props.updateGRFileId(selectedList)
        }

    }

    generalReportCampaignIdChangeSelect = (selectedList) => {
        this.props.updateGRCampaignId(selectedList)
        let campaignSelectedList = []
        selectedList.map(campaign => {
            campaignSelectedList.push(campaign.idLogo)
        })
        this.props.fetchCampaignFiles(campaignSelectedList)
    }

    generalReportCampaignIdChangeRemove = (selectedList) => {
        if(selectedList.length){
            this.props.updateGRCampaignId(selectedList)
        }else{
            this.props.updateGRCampaignId(selectedList)
            this.props.updateGRFileId(selectedList)
        }

    }

    generalReportFileIdChangeSelect = (selectedList) => {
        this.props.updateGRFileId(selectedList)
    }

    generalReportFileIdChangeRemove = (selectedList) => {
        this.props.updateGRFileId(selectedList)
    }

    generalReportDateStartChange(dateStart) {
        this.props.updateGRDateStart(dateStart)
    }

    generalReportDateEndChange(dateEnd) {
        this.props.updateGRDateEnd(dateEnd)
    }

    generalReportWhatsappChange(whatsapp) {
        if(whatsapp === true){
            this.props.updateGRWhatsapp(true)
        }else if(whatsapp === false){
            this.props.updateGRWhatsapp(false)
        }
    }

    generalReportSmsChange(sms) {
        if(sms === true){
            this.props.updateGRSms(true)
        }else if(sms === false){
            this.props.updateGRSms(false)
        }
    }

    generalReportEmailChange(email) {
        if(email === true) {
            this.props.updateGREmail(true)
        }else if(email === false){
            this.props.updateGREmail(false)
        }
        // this.props.getGeneralReport(this.props.generalReport)
    }

    generalReportOrdinaryChange(ordinary) {
        if(ordinary === true) {
            this.props.updateGROrdinary(true)
        }else if(ordinary === false) {
            this.props.updateGROrdinary(false)
        }
        // this.props.getGeneralReport(this.props.generalReport)
    }

    generalReportFutureDateChange(futureDate) {
        if(futureDate === true) {
            this.props.updateGRFutureDate(true)
        }else if(futureDate === false) {
            this.props.updateGRFutureDate(false)
        }
    }

    generalReportStatusChangeSelect = (selectedList) => {
        this.props.updateGRStatus(selectedList)
    }

    generalReportStatusChangeRemove=(selectedList) => {
        this.props.updateGRStatus(selectedList)
    }

    fileStatsBankIdChange(bankId) {
        this.props.updateFileStatsBankId(bankId)
    }

    fileStatsCorporateIdChange(corporateId) {
        this.props.updateFileStatsCorporateId(corporateId)
    }

    getFileStats = (event) => {
        event.preventDefault();
        this.props.getFileStats(this.props.corporateFileStats)
    }

    plickStatsBankIdChange(bankId) {
        this.props.updatePlickStatsBankId(bankId)
    }

    getPlickStats = (event) => {
        event.preventDefault();
        this.props.getPlickStats(this.props.plickStatsBankId)
    }

    getReport = (event) => {
        event.preventDefault();
        if (this.props.generalReportBank.length === 0){
            this.setState({
                bankEmpty: true
            })
        } else {
            this.setState({
                bankEmpty: false
            })
            let reportVar = this.props.reportFilter

            this.props.fetchReport(reportVar)

            event.preventDefault();
            var node = document.getElementById('chartsDiv');
            domtoimage.toPng(node,{bgcolor: '#ffffff'})
                .then((dataUrl) => {
                    this.props.updateChartImage(dataUrl);

                })
                .catch((error) => {
                    console.error('oops, something went wrong!', error);
                });
        }
    }

    downloadReport = (event)=> {
        event.preventDefault();
        if (this.props.generalReportBank.length === 0) {
            this.setState({
                bankEmpty: true
            })
            this.toggleGeneralReportModal()
        } else {
            this.setState({
                bankEmpty: false
            })
            let reportVar=this.props.reportFilter

            this.props.downloadReport(reportVar)
            this.toggleGeneralReportModal()
        }
    }
    
    downloadReportDetails = (event)=> {
        event.preventDefault();

        if(this.props.generalReportBank.length === 0){
            this.setState({
                bankEmpty: true
            })
            this.toggleGeneralReportDetailModal()
        }else{
            this.setState({
                bankEmpty: false
            })
            let reportVar=this.props.reportFilter

            this.props.downloadReportDetails(reportVar)
            this.toggleGeneralReportDetailModal()
        }
    }

    getBankDisable = (role) => {
        if (role !== Roles.PAYDO_ADMIN ||
            role !== Roles.PAYDO_USER ||
            role !== Roles.PAYDO_MANAGER) {
            if(!this.props.generalReportBankList.length) {
                this.props.updateGRBankId(this.props.banks)
                let bankIdSelectedList = []
                this.props.banks.map(bank => {
                    bankIdSelectedList.push(bank.bankId)
                })
                this.props.fetchBankCorporates(bankIdSelectedList)
            }
            return true;
        }
        return false;
    }

    getCorporateDisable = (role) => {
        if (role !== Roles.PAYDO_ADMIN ||
            role !== Roles.PAYDO_USER ||
            role !== Roles.PAYDO_MANAGER ||
            role !== Roles.BANK_ADMIN ||
            role !== Roles.BANK_CORPORATE_ADMIN) {
            if(!this.props.generalReportCorporateList.length) {
                this.props.updateGRCorporateId(this.props.userCorporates)
                let corporateIds = []
                this.props.userCorporates.map(corporate => {
                    corporateIds.push(corporate.corporateSenderId)
                })
                this.props.fetchCorporateCampaigns(corporateIds)
            }
            return true;
        }
        return false;
    }

    getCampaignDisable = () => {
        if (Array.isArray(this.props.generalReportCorporate) &&
            this.props.generalReportCorporate.length) {
            return false;
        }
        return true;
    }

    getFileDisable = () => {
        if (Array.isArray(this.props.generalReportCampaign) &&
            this.props.generalReportCampaign.length) {
            return false;
        }
        return true;
    }
    

    render() {
        let role = this.props.role;
        let fileStats = [];
        fileStats = this.props.corporateFileStatsResponse;

        const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042','#FF6042','#FF7281','#FF9681','#FF5481','#FF7781'];

        let reportResponse = this.props.generalReportResponse;
        let reportChart = ''
        let reportChartStatus = ''
        
        let generalReportModal = ''
        generalReportModal =
          <Modal className="modal-dialog modal-lg"
                 isOpen={this.props.hasGeneralReportModal}
                 presentationStyle="fullScreen"
                 toggle={this.toggleGeneralReportModal}>
              <ModalHeader toggle={this.toggleGeneralReportModal}>
                  <Translate id="report.generalReportModal.header"/>
              </ModalHeader>
              <ModalBody>
                  <div className="pl-lg-12">
                      <Row>
                          <Col lg="12">
                              <Translate id="report.generalReportModal.body"/>
                          </Col>
                      </Row>
                  </div>
              </ModalBody>
              <ModalFooter>
                  <Row>
                      <Col>
                          <Button color="danger" onClick={this.toggleGeneralReportModal}>
                              <Translate id="report.generalReportModal.button.close"/>
                          </Button>
                      </Col>
                      <Col>
                          <Button color="primary" onClick={this.downloadReport}>
                              <Translate id="report.generalReportModal.button.send"/>
                          </Button>
                      </Col>
                  
                  </Row>
              </ModalFooter>
          </Modal>
        
        let generalReportDetailModal = ''
        generalReportDetailModal =
          <Modal className="modal-dialog modal-lg"
                 isOpen={this.props.hasGeneralReportDetailModal}
                 presentationStyle="fullScreen"
                 toggle={this.toggleGeneralReportDetailModal}>
              <ModalHeader toggle={this.toggleGeneralReportDetailModal}>
                  <Translate id="report.generalReportDetailModal.header"/>
              </ModalHeader>
              <ModalBody>
                  <div className="pl-lg-12">
                      <Row>
                          <Col lg="12">
                              <Translate id="report.generalReportDetailModal.body"/>
                          </Col>
                      </Row>
                  </div>
              </ModalBody>
              <ModalFooter>
                  <Row>
                      <Col>
                          <Button color="danger" onClick={this.toggleGeneralReportDetailModal}>
                              <Translate id="report.generalReportDetailModal.button.close"/>
                          </Button>
                      </Col>
                      <Col>
                          <Button color="primary" onClick={this.downloadReportDetails}>
                              <Translate id="report.generalReportDetailModal.button.continue"/>
                          </Button>
                      </Col>
                  
                  </Row>
              </ModalFooter>
          </Modal>
        
        if(reportResponse !== '') {
            reportChart=
                <div style={{ width: '100%', height: 300 }} id="chartCanvas">
                    <ResponsiveContainer>
                        <ComposedChart
                            // ref={ref => convertChart(ref)}
                            data={reportResponse.generalReportData}
                            isAnimationActive={true}
                            margin={{
                                top: 20, right: 30, left: 20, bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis hide="true" dataKey="fileName" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar name='Ordinary WA' dataKey="ordinary.whatsapp" stackId="a" fill="#829FD9" />
                            <Bar name='Ordinary SMS' dataKey="ordinary.sms" stackId="a" fill="#027368" />
                            <Bar name='Ordinary EMAIL' dataKey="ordinary.email" stackId="a" fill="#BABF2A" />
                            <Bar name='Future WA' dataKey="futureDate.whatsapp" stackId="b" fill="#8C8303" />
                            <Bar name='Future SMS' dataKey="futureDate.sms" stackId="b" fill="#735702" />
                            <Bar name='Future EMAIL' dataKey="futureDate.email" stackId="b" fill="#00C49F" />
                            <Line type="monotone" dataKey="total" stroke="#ff7300" />
                            {/*<Bar text="aaa" dataKey="Ordinario" stackId="b" fill="#FF8042" />*/}
                            {/*<Bar  dataKey="Incassato" stackId="b" fill="#FF8042" />*/}
                        </ComposedChart>
                    </ResponsiveContainer>
                </div>

            reportChartStatus=
                <div style={{ width: '100%', height: 300 }} id="reportChart">
                    <ResponsiveContainer >
                        <BarChart
                            // ref={ref => convertStatusChart(ref)}
                            data={reportResponse.generalReportData}
                            isAnimationActive={true}
                            margin={{
                                top: 20, right: 30, left: 20, bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis hide="true" dataKey="fileName" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar name='Ordinary CashedIn' dataKey="ordinary.cashedIn" stackId="a" fill="#0540F2" />
                            <Bar name='Ordinary Expired' dataKey="ordinary.expired" stackId="a" fill="#B84BFF" />
                            <Bar name='Ordinary Suspended' dataKey="ordinary.suspended" stackId="a" fill="#02732A" />
                            <Bar name='Ordinary Refused' dataKey="ordinary.refused" stackId="a" fill="#F2E205" />
                            <Bar name='Future CashedIn' dataKey="futureDate.cashedIn" stackId="b" fill="#F24130" />
                            <Bar name='Future Expired' dataKey="futureDate.expired" stackId="b" fill="#8B8FD9" />
                            <Bar name='Future Suspended' dataKey="futureDate.suspended" stackId="b" fill="#025E73" />
                            <Bar name='Future Refused' dataKey="futureDate.refused" stackId="b" fill="#565BBF" />
                            {/*<Bar text="aaa" dataKey="Ordinario" stackId="b" fill="#FF8042" />*/}
                            {/*<Bar  dataKey="Incassato" stackId="b" fill="#FF8042" />*/}
                        </BarChart>
                    </ResponsiveContainer>
                </div>
        }
        // ['#0088FE', '#00C49F', '#FFBB28', '#FF8042','#FF6042','#FF7281'];
        let reportPart=<Row>
            <Col>
                {reportChart}
            </Col>
        </Row>

        let reportPartStatus=<Row>
            <Col>
                {reportChartStatus}
            </Col>
        </Row>

        let corporatesCharts=
            <Row>
                <Col>
                    <div style={{ width: '100%', height: 300 }}>
                        <ResponsiveContainer>
                            <PieChart>
                                <Pie
                                    dataKey="value"
                                    isAnimationActive={true}
                                    data={fileStats}
                                    outerRadius={80}
                                    fill="#8884d8"
                                    label
                                >
                                    {
                                        fileStats.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)
                                    }
                                </Pie>
                                <Tooltip />
                                <Legend layout={"vertifcal"} align="left" verticalAlign="top" height={36}/>
                            </PieChart>
                        </ResponsiveContainer>
                    </div>
                </Col>
            </Row>
        // let plicksTitle="Plicks"
        let plickStats=this.props.plickStatsResponse;
        let plicks=
            <Row >
                <Col >
                    <div style={{ width: '100%', height: 300 }}>
                        <ResponsiveContainer>
                            <PieChart>
                                <Pie
                                    dataKey="value"
                                    isAnimationActive={true}
                                    data={plickStats}
                                    outerRadius={80}
                                    fill="#8884d8"
                                    label
                                >
                                    {
                                        plickStats.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)
                                    }
                                </Pie>
                                <Tooltip />
                                <Legend layout={"vertifcal"} align="left" verticalAlign="top" height={36}/>
                            </PieChart>
                        </ResponsiveContainer>
                    </div>
                </Col>
            </Row>

        let generalReportsTableColumns=[
            { dataField: 'fileName', text: <Translate id="report.distinta"/>,classes:'',
                formatter: (cellContent, row) => (
                    <div className={""}>
                        <div className="customName" >
                            { row.fileName }
                        </div>
                        <u><small><span style={{color:"blue"}} data-tip={ row.fileName }>Show More</span></small></u>
                        <ReactTooltip place="top" type="info" effect="float">
                            {/*<span></span>*/}
                        </ReactTooltip>
                    </div>
                )
            },
            { dataField: 'ordinary.total', text: "Ordinary", align: 'center' },
            { dataField: 'futureDate.total', text: "FutureDate", align: 'center' },
            { dataField: 'whatsapp', text: "Whatsapp", align: 'center' },
            { dataField: 'sms', text: "SMS", align: 'center' },
            { dataField: 'email', text: "Email",align: 'center' },
            { dataField: 'cashedIn', text: "Cashed", align: 'center' },
            { dataField: 'expired', text: "Expired", align: 'center' },
            { dataField: 'suspended', text: "Suspended", align: 'center' },
            { dataField: 'refused', text: "Refused", align: 'center' },
        ]
        let generalReportsTable = reportResponse === '' ? null :
            <BootstrapTable bootstrap4 headerClasses="thead-light" classes="FixedTable wordwrap align-items-center table-flush" keyField='id' data={ reportResponse.generalReportData }
                            columns={ generalReportsTableColumns } pagination={ paginationFactory() }
            />

        let bankDisable=this.getBankDisable(role);
        let corporateDisable=this.getCorporateDisable(role);
        let campaignDisable=this.getCampaignDisable();
        let fileDisable=this.getFileDisable();
        let generalReports=
            <form onSubmit={this.getReport}>
                <div>
                    <Row>
                        <Col>
                            <FormGroup>
                                <label className="form-control-label" htmlFor="language">
                                    <Translate id="report.bank"/>
                                </label>
                                <Translate>
                                    {({ translate }) =>
                                        <Multiselect
                                            options={this.props.banks} // Options to display in the dropdown
                                            selectedValues={this.props.generalReportBank} // Preselected value to persist in dropdown
                                            onSelect={this.generalReportBankIdChangeSelect} // Function will trigger on select event
                                            onRemove={this.generalReportBankIdChangeRemove} // Function will trigger on remove event
                                            displayValue="bankName" // Property name to display in the dropdown options
                                            placeholder={translate("report.bank")}
                                            disable={bankDisable}
                                            style={{
                                                option: {},
                                                chips : { background: "#b62377" },
                                                searchBox: { border: "none", borderBottom: "1px solid blue", borderRadius: "0px" },
                                                multiselectContainer: {width:"100%"},
                                            }}

                                        />
                                    }
                                </Translate>
                                {this.state.bankEmpty === true ? <label style={{color:"red"}}><Translate id="report.bankEmpty" /></label>:""}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <label className="form-control-label" htmlFor="language">
                                    <Translate id="report.corporate"/>
                                </label>
                                <Translate>
                                    {({ translate }) =>
                                        <Multiselect
                                            options={this.props.corporates} // Options to display in the dropdown
                                            selectedValues={this.props.generalReportCorporate} // Preselected value to persist in dropdown
                                            onSelect={this.generalReportCorporateIdChangeSelect} // Function will trigger on select event
                                            onRemove={this.generalReportCorporateIdChangeRemove} // Function will trigger on remove event
                                            displayValue="corporateSenderName" // Property name to display in the dropdown options
                                            placeholder={translate("report.corporate")}
                                            disable={corporateDisable}
                                            style={{
                                                option: {},
                                                chips : { background: "#b62377" },
                                                searchBox: { border: "none", borderBottom: "1px solid blue", borderRadius: "0px" },
                                                multiselectContainer: {width:"100%"},
                                            }}

                                        />}
                                </Translate>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <label className="form-control-label" htmlFor="language">
                                    <Translate id="report.campaign"/>
                                </label>
                                <Translate>
                                    {({ translate }) =>
                                        <Multiselect
                                            options={this.props.campaigns} // Options to display in the dropdown
                                            selectedValues={this.props.generalReportCampaign} // Preselected value to persist in dropdown
                                            onSelect={this.generalReportCampaignIdChangeSelect} // Function will trigger on select event
                                            onRemove={this.generalReportCampaignIdChangeRemove} // Function will trigger on remove event
                                            displayValue="campaignName" // Property name to display in the dropdown options
                                            placeholder={translate("report.campaign")}
                                            disable={campaignDisable}
                                            style={{
                                                option: {},
                                                chips : { background: "#b62377" },
                                                searchBox: { border: "none", borderBottom: "1px solid blue", borderRadius: "0px" },
                                                multiselectContainer: {width:"100%"},
                                            }}

                                        />}
                                </Translate>

                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <label className="form-control-label" htmlFor="language">
                                    <Translate id="report.files"/>
                                </label>
                                <Translate>
                                    {({ translate }) =>
                                        <Multiselect
                                            options={this.props.files} // Options to display in the dropdown
                                            selectedValues={this.props.generalReportFileId} // Preselected value to persist in dropdown
                                            onSelect={this.generalReportFileIdChangeSelect} // Function will trigger on select event
                                            onRemove={this.generalReportFileIdChangeRemove} // Function will trigger on remove event
                                            displayValue="originalFileName" // Property name to display in the dropdown options
                                            placeholder={translate("report.files")}
                                            disable={fileDisable}
                                            style={{
                                                option: {},
                                                chips : { background: "#b62377" },
                                                searchBox: { border: "none", borderBottom: "1px solid blue", borderRadius: "0px" },
                                                multiselectContainer: {width:"100%"},
                                            }}

                                        />
                                    }
                                </Translate>

                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col><Button color="primary" id="toggler" style={{ marginBottom: '1rem' }}>
                            <Translate id="report.button.filter"/>
                        </Button>
                        </Col>
                        <Row className="row justify-content-center">
                            <Col className="verticalCenter">
                                <Button id="downloadDetailsReport" className="btn-success" onClick={this.toggleGeneralReportDetailModal}>
                                    <Translate id="report.button.downloadDetails"/>
                                </Button>
                            </Col>
                            <Col className="verticalCenter">
                                <Button id="downloadReport" className="btn-success" onClick={this.toggleGeneralReportModal}>
                                    <Translate id="report.button.download"/>
                                </Button>
                            </Col>
                            <Col className="verticalCenter">
                                <Button id="reportButton" className="btn-success" type="submit">
                                    {/*<i className="fas fa-arrow-left text-primary" />*/}
                                    <Translate id="report.button.getreport"/>
                                </Button>
                            </Col>
                        </Row>
                    </Row>
                    <UncontrolledCollapse toggler="#toggler">
                        <Row>
                            <Col>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="language">
                                                Date Start
                                            </label>
                                            <input type="date" value={this.props.generalReportDateStart} onChange={(event) => this.generalReportDateStartChange(event.target.value)}/>
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="language">
                                                Date End
                                            </label>
                                            <input type="date" value={this.props.generalReportDateEnd} onChange={(event) => this.generalReportDateEndChange(event.target.value)}/>
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <Row>
                                            <Col>
                                                <FormGroup>

                                                    <Translate id="report.filter.whatsapp"/> : <input id="whatsapp" value={this.props.generalReportWhatsapp} type="checkbox"
                                                                                                      checked={this.props.generalReportWhatsapp} onChange={(event) => this.generalReportWhatsappChange(event.target.checked)} />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <FormGroup>
                                                    <Translate id="report.filter.sms"/> : <input id="sms" value={this.props.generalReportSms} type="checkbox"
                                                                                                 checked={this.props.generalReportSms} onChange={(event) => this.generalReportSmsChange(event.target.checked)} />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <FormGroup>
                                                    <Translate id="report.filter.email"/> : <input id="email" value={this.props.generalReportEmail} type="checkbox"
                                                                                                   checked={this.props.generalReportEmail} onChange={(event) => this.generalReportEmailChange(event.target.checked)}  />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col>
                                        <Row>
                                            <Col>
                                                <FormGroup>
                                                    <Translate id="report.filter.oridinary"/> : <input id="ordinary" value={this.props.generalReportOrdinary} type="checkbox"
                                                                                                       checked={this.props.generalReportOrdinary} onChange={(event) => this.generalReportOrdinaryChange(event.target.checked)} />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <FormGroup>
                                                    <Translate id="report.filter.futureDate"/> : <input id="future" value={this.props.generalReportFutureDate} type="checkbox"
                                                                                                        checked={this.props.generalReportFutureDate} onChange={(event) => this.generalReportFutureDateChange(event.target.checked)}/>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="language">
                                                <Translate id="report.filter.status"/>
                                            </label>
                                            <Translate>
                                                {({ translate }) =>
                                                    <Multiselect
                                                        options={this.props.plickStatusType} // Options to display in the dropdown
                                                        selectedValues={this.props.generalReportStatus} // Preselected value to persist in dropdown
                                                        onSelect={this.generalReportStatusChangeSelect} // Function will trigger on select event
                                                        onRemove={this.generalReportStatusChangeRemove} // Function will trigger on remove event
                                                        // displayValue="originalFileName" // Property name to display in the dropdown options
                                                        isObject={true}
                                                        displayValue="value" // Property name to display in the dropdown options
                                                        placeholder={translate("report.filter.status")}
                                                        style={{
                                                            option: {},
                                                            chips : { background: "#b62377" },
                                                            searchBox: { border: "none", borderBottom: "1px solid blue", borderRadius: "0px" },
                                                            multiselectContainer: {width:"100%"},
                                                        }}

                                                    />}
                                            </Translate>

                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </UncontrolledCollapse>
                    <Row>
                        <Col>
                            {generalReportsTable}
                        </Col>
                    </Row>
                    <div id="chartsDiv">
                        <Row>
                            <Col className={"col-12"}>{reportPart}</Col>
                        </Row>
                        <Row>
                            <Col className={"col-12"}>{reportPartStatus}</Col>
                        </Row>
                    </div>
                </div>
            </form>
        let bankDisabled=Roles.checkBankDisabledReport(role,Roles.MODULE_BANK);
        // let corporateDisabled=Roles.checkCorporateDisabledReport(role,Roles.MODULE_CORPORATE);

        let bankOptions=''
        let corporateOptions=''
        let plickStatsBankOptions=''

        if(Roles.PAYDO_ADMIN === this.props.role){
            bankOptions=
                <FormControl as="select"
                         value={this.props.corporateFileStatsBankId}
                         required={true}

                         onChange={(newValue) => {
                             this.fileStatsBankIdChange(newValue.target.value);
                         }}
            >
                <option selected={bankDisabled}></option>
                {this.props.banks.map((item)=>{
                    return <option value={item.bankId}>{item.bankName}</option>
                })}
            </FormControl>

            corporateOptions=
                <FormControl as="select"
                             value={this.props.corporateFileStatsCorporateId}

                             onChange={(newValue) => {
                                 this.fileStatsCorporateIdChange(newValue.target.value);
                             }}
                >
                    <option></option>
                    {this.props.userCorporates.map((item)=>{
                        return <option value={item.corporateSenderId}>{item.corporateSenderName}</option>
                    })}
                </FormControl>

            plickStatsBankOptions=<FormControl className='form-control-alternative'
                                               as="select"
                                               value={this.props.plickStatsBankId}
                                               required={true}
                                               onChange={(newValue) => {
                                                   this.plickStatsBankIdChange(newValue.target.value);
                                               }}
            >
                <option></option>
                {this.props.banks.map((item)=>{
                    return <option value={item.bankId}>{item.bankName}</option>
                })}
            </FormControl>
        } else if(Roles.BANK_ADMIN === this.props.role || Roles.BANK_CORPORATE_ADMIN === this.props.role){
            let userBankId=this.props.idBank;
            this.fileStatsBankIdChange(userBankId);
            let bankName=this.props.banks.map((item) => {
                if(userBankId === item.bankId){
                    return item.bankName;
                }
                return ""
            })
            bankOptions =
                <Translate>
                    {({ translate }) =>
                        <Input
                            disabled="disabled"
                            className="form-control-alternative"
                            value={bankName}
                            // onChange={this.onCorporateSenderIdChange}
                            id="bankId"
                            placeholder={translate("report.bank")}
                            type="text"/>}
                </Translate>
            corporateOptions=
                <FormControl as="select"
                                          value={this.props.corporateFileStatsCorporateId}

                                          onChange={(newValue) => {
                                              this.fileStatsCorporateIdChange(newValue.target.value);
                                          }}
            >
                <option></option>
                {this.props.userCorporates.map((item)=>{

                    return <option value={item.corporateSenderId}>{item.corporateSenderName}</option>
                })}
            </FormControl>

            this.plickStatsBankIdChange(userBankId);
            plickStatsBankOptions=
                <Translate>
                    {({ translate }) =>
                        <Input
                            disabled="disabled"
                            className="form-control-alternative"
                            value={bankName}
                            // onChange={this.onCorporateSenderIdChange}
                            id="bankId"
                            placeholder={translate("report.bank")}
                            type="text"/>}
                </Translate>


        }else if(Roles.CORPORATE_ADMIN === this.props.role){
            let userBankId=this.props.idBank;
            this.fileStatsBankIdChange(userBankId);
            let bankName=this.props.banks.map((item) => {
                if(userBankId === item.bankId){
                    return item.bankName;
                }
                return ""
            })
            bankOptions =
                <Translate>
                    {({ translate }) =>
                        <Input
                            disabled="disabled"
                            className="form-control-alternative"
                            value={bankName}
                            // onChange={this.onCorporateSenderIdChange}
                            id="bankId"
                            placeholder={translate("report.bank")}
                            type="text"/>}
                </Translate>
            let corporateSenderId=this.props.corporateSenderId;
            this.fileStatsCorporateIdChange(corporateSenderId);
            let corporateName=this.props.corporates.map((item) => {
                if(corporateSenderId === item.corporateSenderId){
                    return item.corporateSenderName;
                }
                return ""
            })

            corporateOptions=
                <Translate>
                    {({ translate }) =>
                        <Input
                            disabled="disabled"
                            className="form-control-alternative"
                            value={corporateName}
                            // onChange={this.onCorporateSenderIdChange}
                            id="corporateSenderId"
                            placeholder={translate("report.corporate")}
                            type="text"/>}
                </Translate>
        }


        let fileStatsCorporate=this.props.role === Roles.PAYDO_ADMIN
        || this.props.role === Roles.BANK_ADMIN
        || this.props.role === Roles.BANK_CORPORATE_ADMIN
        ||  this.props.role === Roles.CORPORATE_ADMIN ?
            <div>
                <Row>
                    <Col><Button color="#45007F" id="fileStatsToggler" style={{ marginBottom: '1rem' }}>
                        <Translate id="report.button.fileStatsToggle"/>
                    </Button>
                    </Col>
                </Row>
                <UncontrolledCollapse toggler="#fileStatsToggler">
                    <form onSubmit={this.getFileStats}>
                        <Row>
                            <Col>

                                <FormGroup>
                                    <label className="form-control-label" htmlFor="bank">
                                        <Translate id="report.bank"/>
                                    </label>
                                    {bankOptions}
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="language">
                                        <Translate id="report.corporate"/>
                                    </label>
                                    {corporateOptions}
                                </FormGroup>
                            </Col>
                            <Row className="row justify-content-center">
                                <Col className="verticalCenter">
                                    <Button id="reportButton" className="btn-success" type="submit">
                                        {/*<i className="fas fa-arrow-left text-primary" />*/}
                                        <Translate id="report.button.getfilestats"/>
                                    </Button>
                                </Col>
                            </Row>
                        </Row>
                    </form>
                    {corporatesCharts}
                </UncontrolledCollapse> </div>: ""
            let plickStatsBank=this.props.role === Roles.PAYDO_ADMIN
            || this.props.role === Roles.BANK_ADMIN || this.props.role === Roles.BANK_CORPORATE_ADMIN ?
                <div>
                    <Row>
                        <Col><Button color="#45007F" id="plickStatsToggler" style={{ marginBottom: '1rem' }}>
                            <Translate id="report.button.plickToggle"/>
                        </Button>
                        </Col>
                    </Row>
                    <UncontrolledCollapse toggler="#plickStatsToggler">
                        <form onSubmit={this.getPlickStats}>
                            <Row>
                                <Col>

                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="language">
                                            <Translate id="report.bank"/>
                                        </label>
                                        {plickStatsBankOptions}
                                    </FormGroup>
                                </Col>
                                <Row className="row justify-content-center">
                                    <Col className="verticalCenter">
                                        <Button id="reportButton" className="btn-success" type="submit">
                                            {/*<i className="fas fa-arrow-left text-primary" />*/}
                                            <Translate id="report.button.getplickstats"/>
                                        </Button>
                                    </Col>
                                </Row>
                            </Row>
                        </form>
                        {plicks}
                    </UncontrolledCollapse>
                </div> : ""
        return(
            <>
                <Header />
                <Container className="mt--5" fluid>
                    <Row>
                        <div className="col" style={{paddingBottom:"2%"}}>
                            <Card className="shadow">
                                <CardHeader className="border-0">
                                    <Row>
                                        <div className="col">
                                            <h3 className="mb-0"><Translate id="report.header"/></h3>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <CardBody>

                                    {generalReports}
                                    <hr></hr>
                                    {fileStatsCorporate}
                                    <hr></hr>
                                    {plickStatsBank}
                                </CardBody>
                            </Card>

                        </div>
                    </Row>
                    {generalReportModal}
                    {generalReportDetailModal}
                </Container>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        idBank: state.authentication.authenticatedUser.idBank,
        corporateSenderId: state.authentication.authenticatedUser.corporateSenderId,

        banks: state.bank.banks,
        userCorporates: state.corporate.corporates,
        corporates: state.report.corporates,
        files: state.report.files,
        campaigns: state.report.campaigns,
        //General Report Vars
        reportFilter: state.report.reportFilter,
        generalReportBank:state.report.reportFilter.bankId,
        generalReportBankList:state.report.reportFilter.bankIdsSelected,
        generalReportCorporate:state.report.reportFilter.corporateId,
        generalReportCorporateList:state.report.reportFilter.corporateIdsSelected,
        generalReportCampaign:state.report.reportFilter.campaignId,
        generalReportCampaignList:state.report.reportFilter.campaignIdsSelected,
        generalReportFile:state.report.reportFilter.fileId,
        generalReportDateStart:state.report.reportFilter.dateStart,
        generalReportDateEnd:state.report.reportFilter.dateEnd,
        generalReportWhatsapp:state.report.reportFilter.whatsapp,
        generalReportSms:state.report.reportFilter.sms,
        generalReportEmail:state.report.reportFilter.email,
        generalReportOrdinary:state.report.reportFilter.ordinary,
        generalReportFutureDate:state.report.reportFilter.futureDate,
        generalReportStatus:state.report.reportFilter.status,

        corporateFileStats:state.report.corporateFileStats,
        corporateFileStatsBankId:state.report.corporateFileStats.bankId,
        corporateFileStatsCorporateId:state.report.corporateFileStats.corporateId,

        bankStats:state.report.bankStats,
        bankStatsBankId:state.report.bankStats.bankId,
        corporateStats:state.report.corporateStats,
        corporateStatscorporateId:state.report.corporateStats.corporateId,

        generalReportResponse:state.report.reportResponse,
        corporateFileStatsResponse:state.report.corporateFileStatsResponse,

        plickStatusType:state.report.plickStatusType,

        plickStatsBankId:state.report.plickStatsBankId,
        plickStatsResponse:state.report.plickStatsResponse,

        role : state.authentication.authenticatedUser.role,
        hasGeneralReportModal: state.report.hasGeneralReportModal,
        hasGeneralReportDetailModal: state.report.hasGeneralReportDetailModal,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchReport:(generalReport)=>dispatch({type: actions.FETCH_REPORT_GENERAL_REQUEST, value: generalReport}),
        downloadReport:(generalReport)=>dispatch({type: actions.FETCH_REPORT_GENERAL_DOWNLOAD_REQUEST, value: generalReport}),
        downloadReportDetails:(generalReport)=>dispatch({type: actions.FETCH_REPORT_GENERAL_DETAILS_DOWNLOAD_REQUEST, value: generalReport}),
        fetchBanks: () => dispatch({ type: actions.FETCH_BANKS_REQUEST }),
        fetchCorporates: () => dispatch({ type: actions.FETCH_CORPORATES_REQUEST }),
        fetchFile: () => dispatch({ type: actions.FETCH_FILES_REQUEST }),
        fetchCampaign: () => dispatch({ type: actions.FETCH_CAMPAIGN_REQUEST }),
        fetchPlickStatusType:() => dispatch({type:actions.FETCH_REPORT_PLICKSTATUS_TYPE_REQUEST}),

        updateGRBankId:(bankId)=>dispatch({type:actions.REPORT_GENERAL_BANK_FIELD_CHANGE_REQUEST,value:bankId}),
        updateGRCorporateId:(corporateId)=>dispatch({type:actions.REPORT_GENERAL_CORPORATE_FIELD_CHANGE_REQUEST,value:corporateId}),
        updateGRCampaignId:(campaignId)=>dispatch({type:actions.REPORT_GENERAL_CAMPAIGN_FIELD_CHANGE_REQUEST,value:campaignId}),
        updateGRFileId:(fileId)=>dispatch({type:actions.REPORT_GENERAL_FILE_FIELD_CHANGE_REQUEST,value:fileId}),
        updateGRDateStart:(dateStart)=>dispatch({type: actions.REPORT_GENERAL_DATESTART_FIELD_CHANGE_REQUEST, value: dateStart}),
        updateGRDateEnd:(dateEnd)=>dispatch({type: actions.REPORT_GENERAL_DATEEND_FIELD_CHANGE_REQUEST, value: dateEnd}),
        updateGRWhatsapp:(whatsapp)=>dispatch({type: actions.REPORT_GENERAL_WHATSAPP_FIELD_CHANGE_REQUEST, value: whatsapp}),
        updateGRSms:(sms)=>dispatch({type: actions.REPORT_GENERAL_SMS_FIELD_CHANGE_REQUEST, value: sms}),
        updateGREmail:(email)=>dispatch({type: actions.REPORT_GENERAL_EMAIL_FIELD_CHANGE_REQUEST, value: email}),
        updateGROrdinary:(ordinary)=>dispatch({type: actions.REPORT_GENERAL_ORDINARY_FIELD_CHANGE_REQUEST, value: ordinary}),
        updateGRFutureDate:(futureDate)=>dispatch({type: actions.REPORT_GENERAL_FUTUREDATE_FIELD_CHANGE_REQUEST, value: futureDate}),
        updateGRStatus:(status)=>dispatch({type: actions.REPORT_GENERAL_STATUS_FIELD_CHANGE_REQUEST, value: status}),

        updateChartImage:(image)=>dispatch({type: actions.REPORT_GENERAL_CHART_IMAGE, value: image}),

        updateFileStatsBankId:(bankId)=>dispatch({type: actions.REPORT_CORPORATE_FILE_STATS_BANK_FIELD_CHANGE_REQUEST, value: bankId}),
        updateFileStatsCorporateId:(corporateId)=>dispatch({type: actions.REPORT_CORPORATE_FILE_STATS_CORPORATE_FIELD_CHANGE_REQUEST, value: corporateId}),
        getFileStats:(fileStats)=>dispatch({type: actions.FETCH_REPORT_CORPORATE_FILE_STATS_REQUEST, value: fileStats}),

        updatePlickStatsBankId:(bankId)=>dispatch({type:actions.PLICK_STATS_BANK_FIELD_CHANGE_REQUEST,value:bankId}),
        getPlickStats:(bankId)=>dispatch({type:actions.FETCH_REPORT_PLICK_STATS_REQUEST,value:bankId}),

        fetchBankCorporates:(bankIds)=>dispatch({type:actions.FETCH_REPORT_CORPORATE_REQUEST,value:bankIds}),
        fetchCorporateCampaigns:(corporateIds)=>dispatch({type:actions.FETCH_REPORT_CAMPAIGN_REQUEST,value:corporateIds}),
        fetchCampaignFiles:(campaignIds)=>dispatch({type:actions.FETCH_REPORT_FILES_REQUEST,value:campaignIds}),
        toggleGeneralReportModal: () => dispatch({type: actions.TOGGLE_GENERAL_REPORT_MODAL}),
        toggleGeneralReportDetailModal: () => dispatch({type: actions.TOGGLE_GENERAL_REPORT_DETAIL_MODAL}),
    };
};

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(Report));